<template>
  <div class="black_box">
    <div class="top_box dis_f fle_t">
            <img
        src="@/assets/img/audio_open.png"
        v-if="$store.state.audioPlay"
        class="contro_audio active right"
        @click="$store.commit('setAudioPlay',false)"
        alt
      >
      <img
        src="@/assets/img/audio_close.png"
        @click="$store.commit('setAudioPlay',true)"
        v-else
        class="contro_audio right"
        alt
      >
      <div class="test_list dis_f ali_top fle_no" @click="tagChange(0)">
        <div class="list_tag" :class="{'active':testData[2]==0}">
          <img src="@/assets/img/list_tag_a.png" alt>
        </div>
        <img src="@/assets/img/three_txt1.png" class="list_txt" alt>
      </div>
      <div class="test_list dis_f ali_top fle_no" @click="tagChange(1)">
        <div class="list_tag" :class="{'active':testData[2]==1}">
          <img src="@/assets/img/list_tag_b.png" alt>
        </div>
        <img src="@/assets/img/three_txt2.png" class="list_txt" alt>
      </div>
      <div class="test_list dis_f ali_top fle_no" @click="tagChange(2)">
        <div class="list_tag" :class="{'active':testData[2]==2}">
          <img src="@/assets/img/list_tag_c.png" alt>
        </div>
        <img src="@/assets/img/three_txt3.png" class="list_txt" alt>
      </div>
      <div class="fl1"></div>
      <img
        src="@/assets/img/next_btn.png"
        data-name="3下一题"
        @click="openPage"
        class="test_btn fle_no"
        alt
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["testData"])
  },
  methods: {
    tagChange(num) {
      const data = JSON.parse(JSON.stringify(this.$store.state.testData));
      data[2] = num;
      this.$store.commit("setStoreData", {
        name: "testData",
        data: data
      });
    },
    openPage() {
      if (typeof this.testData[2] == "undefined") {
        this.$toast("请选择选项");
        return;
      }
      this.$router.replace("four");
    }
  }
};
</script>

<style lang="scss" scoped>
.top_box {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  background: url("~@/assets/img/three_bg.png") no-repeat 30px 30px;
  background-size: 650px auto;
  padding: 450px 30px 0;
  .test_list {
    padding: 0 30px;
    flex-shrink: 0;
    margin-bottom: 90px;
    .list_tag {
      flex-shrink: 0;
      margin-right: 20px;
      position: relative;
      &.active::before {
        content: "";
        position: absolute;
        left: 6px;
        top: 80px;
        transform: translateX(-25%);
        width: 114px;
        height: 32px;
        background: url("~@/assets/img/test_checked.png") no-repeat center;
        background-size: cover;
      }
      img {
        width: 74px;
      }
    }
    .list_txt {
      height: 107px;
    }
  }
}
</style>
